/**
 * Created by mauget on 2/12/16.
 */

// ConnectionArrowClass.js

import fabric       from  'fabric.js/dist/fabric.require';
import constants    from  'Constants.js';
import util         from 'util/Util.js';
import formulaService from 'xml/FormulaService.js';
import listService  from 'ListService.js';
import userService  from 'UserService.js';
import widgetUtil   from 'util/WidgetUtil';

const HEAD_LEN_PX    = 18;
const TWO_PI         = 2 * Math.PI;

const PT_FAR_END     = Symbol('PT_FAR_END');
const PT_NEAR_END    = Symbol('PT_NEAR_END');
const PT_BOTH_ENDS   = Symbol('PT_BOTH_ENDS');

const STYLE_CURVED_SIDES    = Symbol('STYLE_CURVED_SIDES');
const STYLE_STRAIGHT_SIDES  = Symbol('STYLE_STRAIGHT_SIDES');
const STYLE_OPEN            = Symbol('STYLE_OPEN');
const STYLE_QUADRATIC       = Symbol('STYLE_QUADRATIC');
const STYLE_BEZIER          = Symbol('STYLE_BEZIER');

// Indices of items in context points array given to us from Fabric.js:
const X1 = 0, Y1 = 1, X2 = 2, Y2 = 3;

export const ConnectionArrowClass = fabric.util.createClass(fabric.Line, {

    type: 'ConnectionArrow',

    initialize: function(pts, opts) {
        this.points  =  pts  || [];
        this.options =  opts || {};

        this.callSuper('initialize', this.points, this.options);

        if (this.model.attributes.autosummary) {
            if (this.options.model.attributes.Parameters) {
                this.parameters = this.options.model.attributes.Parameters;
            }
        }
//        Do not call this for all arrows.  It's not neccesary on behaviors
//        this.initializeImages();

        this.isDraggingCp = false;
        this.objectCaching = false;
        this.visible = opts.visible!==undefined? opts.visible: true;

        this.canvasEvents = {
            'object:moving': this._onObjectMoving
            ,'object:selected': this._onObjectSelected
            // it seems that this listener is not necessary since moving and selecting are doing the job
            //,'mouse:up': this._onCanvasMouseUp
        };

        listService.fcanvas.on(this.canvasEvents);
    },

    direction: undefined,

    initializeImages: function() {
        this.baseImageScript = new Image();
        this.baseImageScript.src = require('editor/icons/workflow_connector_script.png');
        this.baseImageScript.onload = () => {
            listService.fcanvas.renderAll();
        };

        this.baseImageNotification = new Image();
        this.baseImageNotification.src = require('editor/icons/workflow_connector_notification.png');
        this.baseImageNotification.onload = () => {
            listService.fcanvas.renderAll();
        };

        this.baseImageCondition = new Image();
        this.baseImageCondition.src = require('editor/icons/workflow_connector_condition.png');
        this.baseImageCondition.onload = () => {
             listService.fcanvas.renderAll();
        };
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('connection')
        });
    },

    //=========================================================================================
    // Draws an arrowhead in one of five styles.
    // Lifted from http://dbp-consulting.com/scripts/canvasutilities.js with
    // code linting improvements.
    // See _drawArrow method after this method for info about the style.
    //
    // -Lou Mauget, February 13, 2016
    //=========================================================================================
    _drawHead_: function( ctx, x0, y0, x1, y1, x2, y2, style = STYLE_QUADRATIC )    {

        const radius = 3;

        // Preamble:
        ctx.save();

        ctx.beginPath();
        ctx.moveTo( x0, y0 );
        ctx.lineTo( x1, y1 );
        ctx.lineTo( x2, y2 );

        switch(style){

            case STYLE_CURVED_SIDES:
                (() => {
                    // Curved filled, add the bottom as an arcTo curve and fill
                    const backdist = Math.sqrt((x2 - x0) * (x2 - x0) + (y2 - y0) * (y2 - y0));
                    ctx.arcTo(x1, y1, x0, y0, 0.55 * backdist);
                    ctx.fill();
                })();
                break;

            case STYLE_STRAIGHT_SIDES:
                // Straight filled: add the bottom as a line and fill.
                ctx.beginPath();
                ctx.moveTo(x0, y0);
                ctx.lineTo(x1, y1);
                ctx.lineTo(x2, y2);
                ctx.lineTo(x0, y0);
                ctx.fill();
                break;

            case STYLE_OPEN:
                // Unfilled head, just stroke.
                ctx.stroke();
                break;

            case STYLE_QUADRATIC:
                (() => {
                    // Filled head: add the bottom as a quadraticCurveTo curve and fill
                    const cpx = (x0 + x1 + x2) / 3;
                    const cpy = (y0 + y1 + y2) / 3;
                    ctx.quadraticCurveTo(cpx, cpy, x0, y0);
                    ctx.fill();
                })();
                break;

            case STYLE_BEZIER:
                (() => {
                    // Filled head: add the bottom as a bezierCurveTo curve and fill
                    let cp1x, cp1y, cp2x, cp2y, backdist;
                    let shiftamt = 5;
                    if (x2 === x0) {
                        // Avoid a divide by zero if x2==x0
                        backdist = y2 - y0;
                        cp1x = (x1 + x0) / 2;
                        cp2x = (x1 + x0) / 2;
                        cp1y = y1 + backdist / shiftamt;
                        cp2y = y1 - backdist / shiftamt;
                    }
                    else {
                        backdist = Math.sqrt((x2 - x0) * (x2 - x0) + (y2 - y0) * (y2 - y0));
                        const xback = (x0 + x2) / 2;
                        const yback = (y0 + y2) / 2;
                        const xmid = (xback + x1) / 2;
                        const ymid = (yback + y1) / 2;

                        const m = (y2 - y0) / (x2 - x0);
                        const dx = (backdist / (2 * Math.sqrt(m * m + 1))) / shiftamt;
                        const dy = m * dx;

                        cp1x = xmid - dx;
                        cp1y = ymid - dy;
                        cp2x = xmid + dx;
                        cp2y = ymid + dy;
                    }

                    ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x0, y0);
                    ctx.fill();
                })();
                break;
        }
        ctx.restore();
    },


    roundRect(ctx, x, y, width, height, radius, fill, stroke) {
        let _radius = radius;
        let _stroke = stroke;

        if (typeof _stroke === "undefined" ) {
            _stroke = true;
        }
        if (typeof _radius === "undefined") {
            _radius = 5;
        }
        ctx.beginPath();
        ctx.moveTo(x + _radius, y);
        ctx.lineTo(x + width - _radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + _radius);
        ctx.lineTo(x + width, y + height - _radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + _radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - _radius);
        ctx.lineTo(x, y + _radius);
        ctx.quadraticCurveTo(x, y, x + _radius, y);
        ctx.closePath();
        if (_stroke) {
            ctx.stroke();
        }
        if (fill) {
            ctx.fill();
        }
    },


    wrapText(ctx, text, x, y, maxWidth, lineHeight) {
        let maxWidthForText = maxWidth < 10? 10: maxWidth;
        //there is room for 16 characters in a width of 100px
        let wordsPerLine = (maxWidthForText * 16) / 100;
        
        let words = [];
        let validLine = "";
        let tmpLine = '';
        text.split(' ').forEach(word => {
            tmpLine += `${word} `;
            if (tmpLine.length < wordsPerLine) {
                validLine = tmpLine;
            }
            else {
                words.push(validLine);
                validLine = '';
                tmpLine = `${word} `;
            }
        });

        words.push(tmpLine);

        let line = '';
        let lineY = y;

        // Calc the height needed first.
        for(let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + ' ';
            const metrics = ctx.measureText(testLine);
            const testWidth = metrics.width;
            if (testWidth > maxWidthForText && n > 0) {
                line = words[n] + ' ';
                lineY += lineHeight;
            }
            else {
                line = testLine;
            }
        }

        // PF-4045 Replaces  "if boolean-and-boolean-then-assign-boolean" with  the equivalent assign-boolean.
        const drawImages = ( listService.mainKind==='W' && userService.userSettings.attributes[constants.WORKFLOW_MARKERS] ) &&
            ( this.model.get('hasConditions') || this.model.get('hasNotifications') || this.model.get('hasScripts') );

        let height = drawImages? (20+lineY)+20 : (20+lineY);
        // draw box that will contain text
        ctx.fillStyle = "#fff";

        // PF-2345 Curved line label position is midpoint of virtual line joining the Bezier control points, but
        // straight line caption position is midpoint of the actual path.
        const cl = this.captionPosition( this.model );
        this.roundRect(ctx, cl.x - (maxWidth/2), cl.y - 14, maxWidth, height, 10, true);
        ctx.fillStyle = "#000";

        const isCurved = this.model.attributes.lineType === 'bezier';

        // reset
        line = '';
        lineY = isCurved ? cl.y : y;
        const lineX = isCurved ? cl.x : x;
        // now actually write the text
        for(let n = 0; n < words.length; n++) {
            const testLine = line + words[n] + ' ';
            const metrics = ctx.measureText(testLine);
            const testWidth = metrics.width;
            if (testWidth > maxWidthForText && n > 0) {
                ctx.fillText(line, lineX, lineY);
                line = words[n] + ' ';
                lineY += lineHeight;
            }
            else {
                line = testLine;
            }
            
        }
        ctx.fillText(line, lineX, lineY);

        if ( drawImages )  {
            this.drawWorkflowMarkers(ctx, {lineX, lineY});
        }

    },

    captionPosition( model ){
        return (model.attributes.lineType === 'bezier') ? this.computeCpMid( model) : {x:0, y:0};
    },

    //==================================================================================================================
    // Based heavily on  http://www.dbp-consulting.com/tutorials/canvas/CanvasArrow.html
    //
    // _drawArrow( x1, y1, x2, y2, style, which, angle, length) // <== signature
    //
    // x1,y1 - the line of the shaft starts here
    //
    // x2,y2 - the line of the shaft ends here
    //
    // style - type of head to draw
    //    0 - filled head with back a curve drawn with arcTo
    //         some browsers have an  arcTo bug that make this look bizarre
    //    1 - filled head with back a straight line
    //    2 - unfilled but stroked head
    //    3 - filled head with back a curve drawn with quadraticCurveTo
    //    4 - filled head with back a curve drawn with bezierCurveTo
    //
    // function(ctx,x0,y0,x1,y1,x2,y2,style) - a function to draw the head.
    //
    // Point (x1,y1) is the same as the end of the line (x0,y0) and (x2,y2) are the two back corners.
    //
    // The style argument is the 'this' value for the function.
    //
    // default 3 (filled head with quadratic back)
    //
    // which - which end(s) get the arrow
    //    0 - neither
    //    1 - x2,y2 end
    //    2 - x1,y1 end
    //    3 - (i.e. 1+2) both ends
    //
    // default 1 (destination end gets the arrow)
    //
    // angle - the angle θ from shaft to one side of arrow head - default π/8 radians (22 1/2°, half of a 45°)
    //
    // length - the distance d in pixels from arrow point back along the shaft to the back of the arrow head
    //        - default HEAD_LEN_PX
    //
    //==================================================================================================================
    _drawArrow: function( ctx, px1, py1, px2, py2,
                          styleHead = STYLE_QUADRATIC,
                          which = PT_FAR_END,
                          angle = Math.PI/8,
                          d = HEAD_LEN_PX) {

        const
            x1 = Number(px1),
            y1 = Number(py1),
            x2 = Number(px2),
            y2 = Number(py2);

        // Default to using built-in Yoda _drawHead to draw the head, but if the styleHead
        // argument is a function, use it instead
        const fnDrawHead= typeof(styleHead) !== 'function' ? this._drawHead_ : styleHead;

        const tox   = x2, toy   = y2;
        const fromx = x1, fromy = y1;

        ctx.fillStyle = listService.currentSelectedPathId === this.options.model.get('id') ? '#edef51' : '#aaaaaa';
        ctx.strokeStyle = ctx.fillStyle;
        ctx.strokeWidth = this.options.strokeWidth;

        // Calculate the angle of the shaft.
        // PF-2345: ... for either a curved shaft or straight shaft
        // Curved angle is the control point guideline angle that intersects the arrowhead
        const lineangle = ( ma => {
            // If straight, then we're about done ...
            if (ma.lineType === 'straight') {
                return Math.atan2(y2 - y1, x2 - x1);
            }

            // It's curved, but which end? Pair a control point with the guideline that enters the arrow end
            // Note: this code controls arrowhead's alignment with that of the shaft
            if ( which === PT_FAR_END) {
                const
                    c2x = Number(ma.ctrlPoint2x) - this._xOffset(),
                    c2y = Number(ma.ctrlPoint2y) - this._yOffset();
                return Math.atan2( -(c2y - toy), -(c2x - tox));
            }

            if (which === PT_NEAR_END) {
                const
                    c1x = Number(ma.ctrlPoint1x) - this._xOffset(),
                    c1y = Number(ma.ctrlPoint1y) - this._yOffset();
                return Math.atan2(c1y - fromy, c1x - fromx);
            }
        })(this.model.attributes, which);

        // Draw the shaft of the arrow
        this._drawShaft(ctx, this.options.model, {x:fromx, y:fromy}, { x:tox, y:toy} );

        // h is the line length of a side of the arrowhead
        const h = Math.abs(d / Math.cos(angle));

        if ( which === PT_FAR_END || which === PT_BOTH_ENDS  ){	// handle far end arrow head
            const angle1 = lineangle + Math.PI + angle;
            const topx = x2 + Math.cos(angle1) * h;
            const topy = y2 + Math.sin(angle1) * h;

            const angle2 = lineangle + Math.PI - angle;
            const botx = x2 + Math.cos(angle2) * h;
            const boty = y2 + Math.sin(angle2) * h;

            fnDrawHead(ctx, topx, topy, x2, y2, botx, boty, styleHead);
        }
        // NO ELSE!

        if ( which === PT_NEAR_END || which === PT_BOTH_ENDS ){ // handle near end arrow head
            const angle1 = lineangle + angle;
            const topx = x1 + Math.cos(angle1) * h;
            const topy = y1 + Math.sin(angle1) * h;

            const angle2 = lineangle - angle;
            const botx = x1 + Math.cos(angle2) * h;
            const boty = y1 + Math.sin(angle2) * h;

            fnDrawHead(ctx, topx, topy, x1, y1, botx, boty, styleHead);
        }


        function getParameter(prop) {
            let parameter = undefined;

            if (prop) {
                parameter = _.find(prop.Parameter, function (obj) {
                    return obj.id === 'default'
                });
            }
            return parameter;
        }

        ctx.font = '12px Sans-Serif'
        ctx.fillStyle = '#000000';

        ctx.textAlign = 'center';
        let lineCaption = this.options.model ? this.options.model.get('text') : '';
        if (listService.mainKind === 'W') {
            lineCaption = '';
            lineCaption = this.options.model ? this.options.model.get('name') : '';
        }

        const maxWidth = this.options.model ? Number(this.options.model.get('textBoxWidth')) : 100;
        const autoSummary = this.options.model ? util.isTrue(this.options.model.get('autosummary')) : false;

        // replace caption with Formula Text if AutoSummary has been selected.
        if (autoSummary) {
            let formulaText = this.options.model ? this.options.model.get('formulaText') : '';
            // only do this if we don't have text so we don't do this each time the line is drawn (i.e. every move, refresh)
            if (!formulaText) {
                const parameter = getParameter(this.parameters);
                let expression = undefined;
                if (parameter) {
                    expression = parameter.Expression;
                    formulaText = formulaService.convertExpressionToText(expression);
                }
            }
            //PF-4499 Backwards compatibility - no longer shows the caption. 
            if(formulaText && formulaText !== "")
            {
                lineCaption = formulaText;
            }
        }

        if (lineCaption &&  typeof(lineCaption) === 'string' && lineCaption.trim().length > 0) {
            this.wrapText(ctx, lineCaption, 0, 0, maxWidth, 20);
        } else if ( listService.mainKind==='W' && userService.userSettings.attributes[constants.WORKFLOW_MARKERS] )  {
            if ( this.model.get('hasConditions') || this.model.get('hasNotifications') ||
                this.model.get('hasScripts') ) {
                this.drawWorkflowMarkers(ctx, false);
            }
        }

        if (this.options.model.get('branchBooleanDisplay') && this.options.model.get('branchBooleanDisplay') !== "") {
            let x3 = x1;
            let y3 = y1;
            if (which === PT_NEAR_END) {
                x3 = x2 ;
                y3 = y2 ;
            }
            // PF-3974 Alignment of T and F tags depending on where the line starts.
            switch((this.model).get('srcDot')){
                case 0:y3+=8;break;
                case 1:case 2:x3+=8;break;
                case 3:x3+=8;y3-=8;break;
                case 4:y3-=8;break;
                case 5:x3-=8;y3-=8;break;
                case 7:case 6:x3-=8;break;
            }

            if ( util.isTrue( this.options.model.get('branchBooleanDisplay') )) {

                // True/False Indicators for Simple Branch
                ctx.fillStyle = "#009933"; // Green - True
                this.roundRect(ctx, x3 - 8 , y3 - 8 , 16, 16, 2, true);
                ctx.fillStyle = "#fff"; // White Text
                ctx.fillText('T', x3, y3 + 5);
            } else {
                // #cc0000 Red - False
                ctx.fillStyle = "#cc0000"; // Green - True
                this.roundRect(ctx, x3 - 8 , y3 - 8 , 16, 16, 2, true);
                ctx.fillStyle = "#fff"; // White Text
                ctx.fillText('F', x3, y3 + 5);
            }

            // Reset
            ctx.fillStyle = "#000";
        }

    },

    // This is pretty simple:
    _renderYodaStraightShaft(ctx, from, to) {
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
    },

    // x offset is the offset of the line's object-relative x within the outer canvas coordinate system.
    _xOffset() {
        return (this.oCoords.tl.x + this.oCoords.br.x) / 2;
    },

    // Y offset is the offset of the line's object-relative y within the outer canvas coordinate system.
    _yOffset() {
        return (this.oCoords.tl.y + this.oCoords.br.y) / 2;
    },


    // PF-2345 Creates initial control point positions.
    // Call this when changing from a straight to a curved shaft the first time for a given path.
    _genDefaultControlsPoints(ma, from, to) {
        const mx = (to.x + from.x) / 2;
        const my = (to.y + from.y) / 2;

        // Default x or y offset magnitude of a control point from midpoint of the shaft line (i.e half of 20 px)
        const ptOffset = constants.GRIDSIZE_FOR_BEHAVIOR_AND_WORKFLOW/2;

        ma.ctrlPoint1x = mx - ptOffset + this._xOffset();
        ma.ctrlPoint1y = my + ptOffset + this._yOffset();
        ma.ctrlPoint2x = mx + ptOffset + this._xOffset();
        ma.ctrlPoint2y = my - ptOffset + this._yOffset();

    },


    // PF-2345 Adjust associated location for either dragged control point
    // Assumes the target control point contains the model that holds a back-ref to that control point
    // This enables ID'ing the control point that is moving.
    _onObjectMoving(ev) {
        if (ev.target && ev.target.model) {
            const model = ev.target.model;
            const ma = model.attributes;

            // Update controlPoint properties in model.
            if (ev.target === ma.controlPoint1) {
                ma.ctrlPoint1x = ev.e.offsetX;
                ma.ctrlPoint1y = ev.e.offsetY;
            } else if (ev.target === ma.controlPoint2) {
                ma.ctrlPoint2x = ev.e.offsetX;
                ma.ctrlPoint2y = ev.e.offsetY;
            }
        }
    },


    _onObjectSelected(ev) {
        if (ev.target && ev.target.model) {
            const model = ev.target.model;
            const ma = model.attributes;

            if (ev.target === ma.controlPoint1 || ev.target === ma.controlPoint2) {
                listService.isDraggingCp = true;
            }
        }
    },



    //==================================================================================================================
    // PF-2345 A drop of a stage, etc has no ev.e. Otherwise, check if mouse-up within range of a Bezier curved path.
    // This listener handles Bezier mouse hits that the "normal" straight-line Behavior or Workflow mouse-up may miss.
    // Those handlers assume that the path is a straight path. Those may miss a hit on some parts of a curve.
    // This handler is called by fabric.js:
    //==================================================================================================================
    _onCanvasMouseUp( ev ) {
        // Handle event on next turn:
        let isHit = false;

        // Whenever possible, skip unneeded hit tests.
        // FabricJS object mouse event in workflow page or behavior page may have already selected a connection path;
        if (!listService.currentSelectedPathId ) {

            // A drop of a stage, etc has no ev.e. Otherwise, check if mouse-up within range of a bezier curved path, etc.
            if (ev.e) {

                // Look for first Bezier in the crowd that touches the mouse point. May be none.
                listService.fcanvas.forEachObject(w => {

                    if (widgetUtil.isClickedBalloon( w, ev.e )){
                        isHit = true;
                    } else  if (!isHit && w.model && w.model.get('lineType') === 'bezier') {
                        isHit = widgetUtil.isBezierHit(w, ev.e);
                    }
                });
            }
        }
        return isHit;
    },


    //==================================================================================================================
    // PF-2345 Renders red dot control point as a fabric circle so we can drag it and monitor movement via listener
    //==================================================================================================================
    _drawControlPoint(ctx, model, cpNo, x, y, radius) {

        const fcanvas = listService.fcanvas;

        const ma = model.attributes;

        // Instantiate fabric.Circle for point number 1 or 2
        if (!ma[`controlPoint${cpNo}`]) {
            ma[`controlPoint${cpNo}`] = new fabric.Circle({
                left: x + this._xOffset() - radius,
                top: y + this._yOffset() - radius,
                strokeWidth: 0.8,
                radius: radius
            });
        }

        const cp = ma[`controlPoint${cpNo}`];
        // Use model to ID the control point when moving
        if (!cp.model) {
            cp.model = model;
        }

        cp.fill = cp.stroke = constants.BEZIER_CONTROL_COLOR;
        cp.hasBorders = cp.hasControls = false;
        cp.pfKind = constants.CONTROL_PT;

        //---------------
        // Don't add given control point twice to canvas. No no no. Just don't.
        function isObjRendered(canvas, obj) {
            let canvasHasObj = false;
            canvas.forEachObject( w => {
                if (w === obj) {
                    canvasHasObj = true;
                }
            });
            return canvasHasObj;
        }

        if (!isObjRendered(fcanvas, cp)) {
            fcanvas.renderOnAddRemove = false;
            fcanvas.add(cp);
            // Careful: avoid stack overflow with recursive render indirect call to us. Wait for next turn.
            // Do it only here, or we'll get one at every render, new dot or not.
            // First hint is a really persistent spinner when you return to layout (been there).
            window.setTimeout(() => fcanvas.renderAll(), 0);
        }
    },

    //==================================================================================================================
    // Used by _drawBezierControls
    //==================================================================================================================
    _drawControlLine(ctx, x1, y1, x2, y2)  {
        ctx.save();
        ctx.beginPath();
        ctx.lineWidth = 0.8;
        ctx.strokeStyle = constants.BEZIER_CONTROL_COLOR;
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    },

    //==================================================================================================================
    // Used by _drawCurvedShaft PF-2345
    // Draw control points and lines between anchors and control points:
    //==================================================================================================================
    _drawBezierControls(ctx, model) {
        const ma = model.attributes;

        // Draw and position control points, each with a guideline
        this._drawControlPoint(ctx, model, 1, Number(ma.ctrlPoint1x) - this._xOffset(), Number(ma.ctrlPoint1y) - this._yOffset(), constants.BEZIER_CONTROL_RADIUS);
        this._drawControlPoint(ctx, model, 2, Number(ma.ctrlPoint2x) - this._xOffset(), Number(ma.ctrlPoint2y) - this._yOffset(), constants.BEZIER_CONTROL_RADIUS);

        // Draw lines based on actual control points' objects' locations
        const
            cpObj1 = ma.controlPoint1,
            cpObj2 = ma.controlPoint2;

        if (cpObj1 && cpObj2) {
            const
                radius = constants.BEZIER_CONTROL_RADIUS,
                cpLoc1 = { x:cpObj1.left - this._xOffset() + radius,  y: cpObj1.top - this._yOffset() + radius },
                cpLoc2 = { x:cpObj2.left - this._xOffset() + radius,  y: cpObj2.top - this._yOffset() + radius };

            this._drawControlLine(ctx, ma.from.x, ma.from.y, cpLoc1.x, cpLoc1.y);
            this._drawControlLine(ctx, ma.to.x, ma.to.y, cpLoc2.x, cpLoc2.y);
        }
    },

    computeCpMid(model) {
        const ma = model.attributes;

        // Midpoint of the two control points' segment in line's local coordinate system
        return {
            x: -this._xOffset() + (Number(ma.ctrlPoint1x) + Number(ma.ctrlPoint2x)) / 2,
            y: -this._yOffset() + (Number(ma.ctrlPoint1y) + Number(ma.ctrlPoint2y)) / 2
        };
    },

    // PF-2345
    _drawCurvedShaft(ctx, model, from, to) {
        const ma = model.attributes;
        // Cache for move-handler
        ma.self = this;
        ma.model = model;
        ma.from = from;
        ma.to = to;
        this.ctx = ctx; // cache for control point handlers

        // Midpoint of the two control points' segment
        const mid = this.computeCpMid( model ) ;

        // Draw joined pair of quadratic bezier curves
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.quadraticCurveTo(Number(ma.ctrlPoint1x) - this._xOffset(), Number(ma.ctrlPoint1y) - this._yOffset(), mid.x, mid.y);
        ctx.quadraticCurveTo(Number(ma.ctrlPoint2x) - this._xOffset(), Number(ma.ctrlPoint2y) - this._yOffset(), to.x, to.y);
        ctx.stroke();

        if (listService.currentSelectedPathId === ma.id) {
            // Draw bezier controls
            this._drawBezierControls(ctx, model);
        }

    },


    _drawShaft(ctx, model, from, to) {
        const ma = model.attributes;
        if (ma.lineType === 'straight') {
            this._renderYodaStraightShaft(ctx, from, to);
        } else if (ma.lineType === 'bezier') {

            //  conditional on empty control points inbound
            const anyPointIsEmpty = ![ma.ctrlPoint1x, ma.ctrlPoint1y, ma.ctrlPoint2x, ma.ctrlPoint2y].reduce( (a, v) => a && v);
            if (anyPointIsEmpty) {
                this._genDefaultControlsPoints(ma, from, to);
            }
            this._drawCurvedShaft(ctx, model, from, to);
        }
    },


    drawWorkflowMarkers(ctx, lineCaption) {
        const isCurvedPath =  this.model.get('lineType') === 'bezier';
        const offset = isCurvedPath ?  this.computeCpMid(this.model): {x:0, y:0};
        if (!this.baseImageCondition) {
            this.initializeImages();
        }

        const imageSize = 15;
        const imageOffset = imageSize / 2; 
        const imagePadding = 5;

        if ( !lineCaption)  {
            ctx.fillStyle = "#fff";
            this.roundRect(ctx, -55 + offset.x, -2 + offset.y, 110, 20, 10, true);
            ctx.fillStyle = "#000";
        }       
       
        let iconsToDisplay = [];

        //Add the images to the array
        if ( this.model.get('hasConditions') ) {
           iconsToDisplay.push(this.baseImageCondition);
        }
        if ( this.model.get('hasNotifications') ) {
            iconsToDisplay.push(this.baseImageNotification);
        }
        if ( this.model.get('hasScripts') ) {
            iconsToDisplay.push(this.baseImageScript);
        }

        //Move the starting x point according to how many icons are displayed
        let posX = offset.x - (iconsToDisplay.length > 1 ? (imageOffset * iconsToDisplay.length + imagePadding) : imageOffset);
        //The y point is the same for all the icons, it should consider the height of the caption in case it exists
        let posY = lineCaption ? lineCaption.lineY + imageOffset : offset.y;

        _.each(iconsToDisplay, (icon) => {
            ctx.drawImage(icon, posX, posY, imageSize, imageSize);
            //After adding an image add the image size and the image padding to set the new start x position of the next image
            posX = posX + imageSize + imagePadding;
        });        
    },

    //====================================================================================
    // FabricJS calls this override method because we're a custom FabricJS
    // prototypical class. The ctx origin is the center of a bounding rectangle
    // of a line that the caller supplies in this.points array. The array contains
    // x0, y0, x1, and y1. Our _render method delegates to _drawArrow that leverages
    // _drawHead_ to draw a directed arrow. The caller assumes we'll render that arrow
    // such that the arrowhead paints toward the end where the mouse up occurred.
    //
    // It is up to us to determine the arrowhead end, and which of two possible lines
    // that pass from bounding box corners through the center origin. We know the
    // absolute line end points, so we can use arctangent to determine the angle of the
    // line, and, thus, which line to use. The angle quadrant also tells us the direction
    // toward which the desired line points.
    //=====================================================================================
    _render: function(ctx) {

        const arrowheadStyle = STYLE_QUADRATIC;

        ctx.save();

        // Default the drawing tools.
        ctx.lineWidth   = this.options.lineWidth   ? this.options.lineWidth   : constants.CONNECTION_LINE_WIDTH;
        ctx.strokeWidth = this.options.strokeWidth ? this.options.strokeWidth : constants.CONNECTION_LINE_WIDTH;
        ctx.fillStyle   = this.options.fillStyle   ? this.options.fillStyle   : constants.CONNECTION_LINE_2;
        ctx.strokeStyle = this.options.strokeStyle ? this.options.strokeStyle : constants.CONNECTION_LINE_2;

        // Bypass calling superclass Line. DIY. We'll self-draw the line and the arrowhead.

        // We're given a ctx with origin (0,0) at the center of a rectangle that outlines a line. The line connects
        // a pair of diagonal corners of that invisible box. We need to know which "slant" the line is.
        //
        // Let us calculate  the signed angle of that line to determine the direction of four possible directed
        // lines passing through that center origin from a corner to the oppostite corner. That enables us
        // to draw only the one line the user indicated, with an arrowhead at the mouse-up position.

        const lineAngle  = Math.atan2( ( this.points[2] - this.points[0] ), ( this.points[3] - this.points[1] ) )
            * 180 / Math.PI;

        // Inspect the lineAngle in 90 degree quadrants, clockwise from North
        // (North is straight down on screen! East is straight right!)
        if (lineAngle >= 0 && lineAngle <= 90) {

            // Origin -> SE (works)
            this.direction = "SE";
            this._drawArrow(ctx,
                -this.width / 2, -this.height / 2,
                +this.width / 2, +this.height / 2,
                arrowheadStyle, PT_FAR_END);

        } else if (lineAngle > 90 && lineAngle <= 180) {

            // Origin -> NE (works)
            this.direction = "NE";
            this._drawArrow(ctx,
                +this.width / 2, -this.height / 2,
                -this.width / 2, +this.height / 2,
                arrowheadStyle, PT_NEAR_END);

        } else if (-lineAngle > 90  && -lineAngle <= 180) {

            // Origin -> NW (works)
            this.direction = "NW";
            this._drawArrow(ctx,
                -this.width / 2, -this.height / 2,
                +this.width / 2, +this.height / 2,
                arrowheadStyle, PT_NEAR_END);

        } else if (-lineAngle > 0  && -lineAngle <= 90){

            // That leaves ... origin ->  SW (works)
            this.direction = "SW";
            this._drawArrow(ctx,
                +this.width / 2, -this.height / 2,
                -this.width / 2, +this.height / 2,
                arrowheadStyle, PT_FAR_END);
        }

        this.ctx = ctx;

        ctx.restore();

    },


    //==================================================================================================================
    // PF-2345
    // For curved paths only:
    //
    // Bezeir hit test:  https://stackoverflow.com/questions/15987966/hit-detection-on-beziercurves-with-tolerance
    // Call genQuadraticBezierXY for each percent at some step granularity. At each invocation, check isPointInRange.
    // If in range, select the connection represented by this instance.
    // e.g.
    // if (this.isPointInRange( this.genQuadraticBezierXY( percent, startxPt, controlPt,  endPt ), mousePt ) {
    //     // .... trigger this object selected, and then stop stepping the persent
    // }
    // Note that this object is composed of joined curves so we test each until a hit, or no hit-found.
    //
    // var startPt=makePoint(10,100);
    // var controlPt=makePoint(50,30);
    // var endPt=makePoint(90,100);
    //
    // The general algorithm:
    // Generate the Bezier path as a running calculation that steps a point by a percentage step along the pair of curves.
    // At each point, compare the mouse location (in this object's coordinates) with each Bezeir point, within a tolerance.
    //
    // E.g. corresponding joined Bezier pair plot graphics code:
    //
    // ctx.moveTo(from.x, from.y);
    // ctx.quadraticCurveTo(Number(ma.ctrlPoint1x) - this._xOffset(), Number(ma.ctrlPoint1y) - this._yOffset(), mid.x, mid.y);
    // ctx.quadraticCurveTo(Number(ma.ctrlPoint2x) - this._xOffset(), Number(ma.ctrlPoint2y) - this._yOffset(), to.x, to.y);
    //
    // Faram: mouse click point in this ConnectionArrow klass object's coordinate system.
    //==================================================================================================================
    hitTestBezier: function (mousePt) {

        // Following two values are a trade-off between detecting hits on extreme curves and triggering heavy GC
        // 1. A one-percent step
        const step = 0.01;

        // 2. Empirically-determined squared hit tolerance.
        // We want a hit detected on or nearby the bezier curve.
        const tolerance = 400; //this.square(20);

        // This is the hitTestBezier functional result:
        let isHit = false;

        // Midpoint of the two control points' segment
        const midPt = this.computeCpMid( this.model ) ;

        const ma = this.model.attributes;

        // In object-relative coordinates:
        const
            startPt1 = ma.from,
            controlPt1 = {x: Number(ma[`ctrlPoint1x`]) - this._xOffset(), y: Number(ma[`ctrlPoint1y`]) - this._yOffset()},
            endPt1 = midPt;
        const
            startPt2 = midPt,
            controlPt2 = {x: Number(ma[`ctrlPoint2x`]) - this._xOffset(), y: Number(ma[`ctrlPoint2y`]) - this._yOffset()},
            endPt2 = ma.to;

        // We're called for every fabric.js object on the canvas. OMG! So ...
        // Check if path has a caption or workflow marker at its midpoint; if so, if mouse point is contained in the
        // caption or workflow boundary, declare a hit -- we're done.
        // Otherwise:
        // + A Bezier is always inside its easy-to-compute convex hull: a triangle of start, control point, and end point.
        // + It is easy to check if the mouse is inside a triangle.
        // + Skip the heavier Bezier 100-point stepwise hit-test whenever mouse is not inside the triangle.
        // + Our curved path is a pair of Beziers, so hit-test each triangle/hull before conditionally hit-stesting on its Bezier curve.

        const inHull1 = this.isPointInsideConvexHull(mousePt, startPt1, controlPt1, endPt1);

        // Iff mouse is inside Bezier's convex hull: step through its Bezier looking for a hit within tolerance
        for (let percent = 0.0; !isHit && inHull1 && percent < 1.0; percent += step) {
            isHit = this.isPointInRange(this.genQuadraticBezierXY(percent, startPt1, controlPt1, endPt1), mousePt, tolerance);
        }

        // Iff no hit so far, check second Bezier of the pair.
        const inHull2 = !isHit && this.isPointInsideConvexHull(mousePt, startPt2, controlPt2, endPt2);

        // Won't fire if hit found on first curve or on this curve's convex hull:
        for (let percent = 0.0; !isHit && inHull2 && percent < 1.0; percent += step) {
            isHit = this.isPointInRange(this.genQuadraticBezierXY(percent, startPt2, controlPt2, endPt2), mousePt, tolerance);
        }

        return isHit;
    },


    //=================================================================================================================
    // - Use a small computation here to eliminate any expensive Bezier hit test that could never hit our Bezier.
    // - A Bezier is always inside its convex hull. Our quadratic Bezier convex hull is a triangle.
    // - If an argument point is outside this triangle then it could never be considered to intersect on the Bezier.
    //=================================================================================================================
    isPointInsideConvexHull: function (point, vertex1, vertex2, vertex3) {

        const isPointInsideTriangle = (p, v1, v2, v3) => {

            const sign = (p1, p2, p3) => (p1.x - p3.x) * (p2.y - p3.y) - (p2.x - p3.x) * (p1.y - p3.y);

            const
                bool1 = sign(p, v1, v2) < 0.0,
                bool2 = sign(p, v2, v3) < 0.0,
                bool3 = sign(p, v3, v1) < 0.0;

            return (bool1 === bool2) && (bool2 === bool3);
        };

        return isPointInsideTriangle(point, vertex1, vertex2, vertex3);
    },


    makePoint: function (x, y) {
        return({x: x, y: y})
    },

    square(n) {
        return n * n;
    },

    //================================================================
    // Generate a point (x,y) at a percentage distance on bezier path
    // (where percent is a decimal from 0 to 1)
    //================================================================
    genQuadraticBezierXY: function (percent, startPt, controlPt, endPt) {
        // Reduce gc load by factoring out redundant computations; we're called many many times:
        const
            percentSquared = percent * percent,
            oneMinusPercent = 1 - percent,
            oneMinusPercentSquared = this.square(oneMinusPercent),
            twiceOneMinusPercentTimesPercent = 2 * oneMinusPercent * percent;

        const
            x = oneMinusPercentSquared * startPt.x + twiceOneMinusPercentTimesPercent * controlPt.x + percentSquared * endPt.x,
            y = oneMinusPercentSquared * startPt.y + twiceOneMinusPercentTimesPercent * controlPt.y + percentSquared * endPt.y;

        return this.makePoint(x, y);
    },

    //================================================================
    // Returns true if a pair of points are close to each other.
    // - squaredRange is the square of the pixel "closeness" tolerance
    // - testPt would likely be a mouse point.
    //================================================================
    isPointInRange: function (bezPt, testPt, squaredRange) {
        const dx = testPt.x - bezPt.x;
        const dy = testPt.y - bezPt.y;

        return this.square(dx) + this.square(dy) < squaredRange;
    }
});
